const resolveMiddlewareFile = (name) => import(`@/middleware/${name}.js`);

export const getMiddlewares = async (middlewares) => {
  const middlewareEntries = new Set();

  // eslint-disable-next-line no-restricted-syntax
  for (const _middleware of middlewares) {
    const promise = typeof _middleware === 'string'
      ? resolveMiddlewareFile(_middleware)
      : _middleware();

    // eslint-disable-next-line no-await-in-loop
    middlewareEntries.add(await promise.then((module) => module.default));
  }

  return middlewareEntries;
};
